import style from "./AppSearchPage.module.scss";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateState } from "../../../features/counter/counterSlice";
import {
  loadSearchMetaData,
  selectRecentSearches,
  selectSavedSearches,
} from "../../../features/enhancedSearch";
import { extractGuidelineName } from "../../../utils/getGuidelinefromUrlSearchResults";
import { convertSavedSearches } from "../../../features/search/search.util";

const AppSearchRecentAndSaveTab = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const dispatch = useDispatch();
  const recentSearches = useSelector(selectRecentSearches);
  const savedSearches = useSelector(selectSavedSearches);

  const emptySearchMessages = ["You have no recent searches.", "You have no saved searches."];
  const currentResults =
    selectedTab === 0 ? recentSearches?.combinedSearches : convertSavedSearches(savedSearches);

  const recentOrSavedResults = Array.isArray(currentResults) ? currentResults.slice(0, 6) : [];

  useEffect(() => {
    dispatch(loadSearchMetaData());
  }, [dispatch]);

  const handleResultClick = (item) => {
    // viewTopic page reports it as a search to ScholarlyIQ
    if (item.url.startsWith("/viewTopic?etgAccess=true&guidelinePage=")) {
      dispatch(
        updateState({
          C5State: {
            databaseID: extractGuidelineName(item.url).guidelineName || "N/A",
            titleID: item?.title,
            eventType: "Searches Regular",
            searchTerm: item?.searchText || "",
          },
        }),
      );
    }
  };

  return (
    <div>
      <div data-testid="search-tabs" className={style.tabs}>
        <button
          className={classNames({ [style["active"]]: selectedTab === 0 })}
          onClick={() => setSelectedTab(0)}
        >
          Recent
        </button>
        <button
          className={classNames({ [style["active"]]: selectedTab === 1 })}
          onClick={() => setSelectedTab(1)}
        >
          Saved
        </button>
      </div>

      <div className={style.tabContents}>
        {recentOrSavedResults.length > 0 ? (
          recentOrSavedResults.map((item, index) => (
            <div key={index} className={style.tabLine}>
              <Link to={item.url} onClick={() => handleResultClick(item)}>
                <span dangerouslySetInnerHTML={{ __html: item.searchText }} />
              </Link>
            </div>
          ))
        ) : (
          <div className={style.emptyTabLine}>{emptySearchMessages[selectedTab]}</div>
        )}
      </div>
    </div>
  );
};

export default AppSearchRecentAndSaveTab;
